import React from "react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { about } = content;

export const About = () => (
  <Section id="ueber-uns" testId="section-about" className="has-lines overflow-hidden bg-[#f5f6f4]">
    <FlowLines color="#0F9D6E" opacity={[0.055, 0.045]} />
    <Container>
      <Reveal>
        <Label>{about.label}</Label>
        <AccentH2 className="mt-7 max-w-[720px] text-3xl font-bold text-[#1e2532] md:text-[44px]">{about.h2}</AccentH2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-x-16 gap-y-6 lg:mt-12 lg:grid-cols-2">
        <div className="space-y-6">
          {about.paragraphs.slice(0, 2).map((p, i) => (
            <p key={i} className="text-[17px] leading-[1.8] text-[#565f70]">{p}</p>
          ))}
        </div>
        <div className="space-y-6">
          {about.paragraphs.slice(2).map((p, i) => (
            <p key={i} className="text-[17px] leading-[1.8] text-[#565f70]">{p}</p>
          ))}
          <p className="border-t border-[#dfe2e0] pt-6 text-[17px] leading-[1.8] text-[#565f70]">
            <strong className="text-[#1e2532]">{about.highlight}</strong>
            {about.highlightText}
          </p>
        </div>
      </div>
    </Container>
  </Section>
);
